<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config :id="id" :form="form" :inputList="inputList" :isLimit="isLimit" :isDepended="isDepended" :isLogic="isLogic">
      <template slot="self-config">
        <el-form-item>
          <el-button type="primary" @click="showInputConfig">页面布局</el-button>
          <el-button type="primary" @click="showCudConfig">连贯操作</el-button>
        </el-form-item>
        <el-form-item label="操作类型" v-if="typeAdd">
          <el-select v-model="form.show_type">
            <el-option v-for="item in typeOptions" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择外键" v-if="typeMultiAdd">
          <el-select v-model="form.child_field_id">
            <el-option v-for="item in keyFields" :label="item.name + '(' + item.title + ')'" :value="item.field_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打开方式">
          <el-radio-group v-model="form.open_type">
            <el-radio :label="10">页面</el-radio>
            <el-radio :label="20">弹窗</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自动传GET参数">
          <el-radio-group v-model="form.is_query">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-config>
    <input-config
      ref="inputConfig"
      :inputType="inputType"
      :inputTitle="inputTitle"
      :curGroupIds="curGroupIds"
      :conditionLists="form.group"
      @confirmCurField="confirmCurField"
      @confirmCondition="confirmCondition"
      @setConditionListShow="setConditionListShow"
      @setInputListShow="setInputListShow"
      @resetTempInputList="resetTempInputList"
      @setCurGroupIds="setCurGroupIds"
      @showDeleteConfirmDialog="showDeleteConfirmDialog">
    </input-config>
    <input-list
      ref="inputList"
      :inputList="tempInputList"
      @setNewInputList="setNewInputList"
      @openDepentConfig="openDepentConfig"
      @setKeyDepent="setKeyDepent"
      @confirmDepentConfig="confirmDepentConfig">
    </input-list>
    <condition-list
      ref="conditionList"
      :inputList="tempInputList"
      @setNewConditionList="setNewConditionList">
    </condition-list>
    <depent-config
      ref="depentConfig"
      :keyDepent="keyDepent"
      :showName="showName">
    </depent-config>
    <cud-config
      ref="cudConfig"
      :modelId="modelId"
      :cudConfig="form.cud_config"
      @setCudConfig="setCudConfig">
    </cud-config>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import cmsConfig from '../../../../config/cmsConfig'
  import modelConfig from '../../../../config/modelConfig'
  import flowConfig from '../../../../config/flowConfig'
  import inputConfig from '../../../Common/business/inputConfig/inputConfig'
  import inputList from '../../../Common/business/inputConfig/inputList'
  import depentConfig from '../../../Common/business/inputConfig/depentConfig'
  import cudConfig from '../../../Common/business/cudConfig'
  import conditionList from '../conditionList'
  import commonConfig from './commonConfig'
  import inputMixins from './inputMixins' // 页面布局相关方法
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: -1,
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          has_condition: 0, // 是否有条件限制
          field: [], // 所选控件
          group: [], // 可见条件
          is_depend: 0,
          depend_config: [], // 从属限制
          condition: {    // 可见条件
            visible: [],  // 可见
            invisible: [],  // 不可见
            forbiden: []  // 禁用
          },
          is_query: 0,    // 自动传GET参数
          cud_config: [], // cud配置
          is_logic: 0,
          logic_condition: [], // 逻辑限制
          show_type: 20,  // 操作类型
          open_type: 10,   // 打开方式
          child_field_id: null  // 子表外键
        },
        curGroupIds: [], // 可见分组的id
        typeOptions: [
          { id: 20, name: '添加' },
          { id: 30, name: '编辑' },
          { id: 40, name: '详情' }
        ],
        type: null, // 操作类型
        isDepended: true, // 是否开启从属关系配置
        isLogic: true,    // 是否开启逻辑条件配置
        isLimit: true,     // 是否开启可见条件配置
        keyFields: [] // 外键字段
      }
    },
    methods: {
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config) {
              this.form.has_condition = res.data.config.has_condition
              this.form.field = res.data.config.field
              this.form.is_depend = res.data.config.is_depend
              this.form.open_type = res.data.config.open_type
              if (res.data.config.group) {
                this.form.group = res.data.config.group
              }
              if (res.data.config.condition) {
                this.form.condition = res.data.config.condition
              }
              if (res.data.config.depend_config) {
                this.form.depend_config = res.data.config.depend_config
              }
              if (this.typeAdd) { // 添加/编辑/详情
                this.form.show_type = res.data.config.show_type
                if (res.data.config.logic_condition) {
                  this.form.is_logic = res.data.config.is_logic
                  this.form.logic_condition = res.data.config.logic_condition
                  _(this.form.logic_condition).forEach((res) => {
                    res.logicOptions2 = []
                    this.form.field.forEach((field) => {
                      if (res.field_name_2 === field.field_id) {
                        res.logicOptions2.push(field)
                      }
                    })
                  })
                }
              } else if (this.typeMultiAdd) { // 批量添加子数据
                if (res.data.config.child_field_id) {
                  this.form.child_field_id = res.data.config.child_field_id
                }
              }
              if (res.data.config.cud_config) {
                this.form.cud_config = res.data.config.cud_config
              }
              if (res.data.config.is_query) {
                this.form.is_query = res.data.config.is_query
              }
            }
            if (this.typeAdd) { // 添加/编辑/详情
              delete this.form.child_field_id
            } else if (this.typeMultiAdd) { // 批量添加子数据
              delete this.form.show_type
              delete this.form.logic_condition
            } else if (this.typeMultiEdit) { // 批量编辑
              delete this.form.child_field_id
              delete this.form.show_type
              delete this.form.logic_condition
            }
            this.modelId = res.data.model_id
            this.getInputList()
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      setCurGroupIds(tempCurGroupIds) {
        this.curGroupIds = Array.from(new Set(tempCurGroupIds))
        this.curGroupIds.sort(this.sortNumber)
      },
      sortNumber(a, b) {
        return a - b
      },
      confirmCurField(inputs) { // 保存控件配置
        this.form.field = inputs
      },
      confirmCondition(condition) {
        var index = _.findIndex(this.form.group, {
          'group_id': condition.group_id
        })
        if (index < 0) {
          // 新分组
          this.form.group.push(condition)
        } else {
          // 已存在分组，覆盖
          this.form.group[index] = condition
        }
      },
      openDepentConfig() {
        this.$refs.depentConfig.openDialog()
      },
      showCudConfig() {
        this.$refs.cudConfig.openDialog()
      },
      setCudConfig(config) {
        this.form.cud_config = config
      }
    },
    computed: {
      showCondition() {
        return this.form.has_condition == 1
      },
      typeAdd() { // 添加/编辑/详情类型
        return this.type == this.OPERATION_ADD
      },
      typeMultiAdd() { // 批量添加子数据
        return this.type == this.OPERATION_MULTI_ADD
      },
      typeMultiEdit() { // 批量编辑
        return this.type == this.OPERATION_MULTI_EDIT
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.type = this.$route.query.type ? parseInt(this.$route.query.type) : null
      if (this.typeAdd) {
        this.isLogic = true
      } else {
        this.isLogic = false
      }
      this.getDetail()
    },
    watch: {
      'inputList'() {
        this.keyFields = []
        _(this.inputList).forEach((res) => {
          if (res.default.type == this.TYPE_FOREIGNKEY) { // 外键
            this.keyFields.push({
              field_id: res.default.field_id,
              name: res.default.name,
              title: res.default.title
            })
          }
        })
      }
    },
    components: {
      inputConfig,
      inputList,
      commonConfig,
      depentConfig,
      conditionList,
      cudConfig
    },
    mixins: [http, modelConfig, cmsConfig, flowConfig, inputMixins]
  }
</script>


// WEBPACK FOOTER //
// formConfig.vue?b6e675a6